import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

function ReassignmentSectionSkeleton() {
	return (
		<Box>
			{/* Title */}
			<Typography
				sx={{
					fontFamily: "Roboto",
					fontWeight: 500,
					fontSize: "24px",
					lineHeight: "28px",
					color: "#000000DE",
					padding: "45px 45px 16px 45px",
				}}
			>
				<Skeleton width={280} height={28} />
			</Typography>
			<Box sx={{ padding: "0 45px 20px 45px" }}>
				{/* Current Assignment Section */}
				<Box sx={{ marginBottom: "32px" }}>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 500,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#000000DE",
							marginBottom: "16px",
						}}
					>
						<Skeleton width={140} />
					</Typography>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							gap: "24px",
							marginBottom: "20px",
						}}
					>
						<Box sx={{ flex: 1 }}>
							<Typography sx={{ mb: "4px" }}>
								<Skeleton width={80} />
							</Typography>
							<Typography>
								<Skeleton width={220} />
							</Typography>
						</Box>
						<Box sx={{ flex: 1 }}>
							<Typography sx={{ mb: "4px" }}>
								<Skeleton width={120} />
							</Typography>
							<Typography>
								<Skeleton width={180} />
							</Typography>
						</Box>
					</Box>
				</Box>

				{/* New Assignment Section */}
				<Box>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 500,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#000000DE",
							marginBottom: "16px",
						}}
					>
						<Skeleton width={160} />
					</Typography>

					{/* Search Field */}
					<Box sx={{ marginBottom: "16px" }}>
						<Skeleton
							variant='rectangular'
							width='100%'
							height={56}
							sx={{ borderRadius: 1 }}
						/>
					</Box>

					{/* Job Roles List */}
					<Box sx={{ maxHeight: "300px" }}>
						{Array.from({ length: 3 }, (_, index) => (
							<Box
								key={index}
								sx={{
									border: "1px solid #E0E0E0",
									borderRadius: "4px",
									padding: "12px 16px",
									marginBottom: "8px",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Skeleton width={200} height={24} />
								<Skeleton width={80} height={20} />
							</Box>
						))}
					</Box>
				</Box>
			</Box>

			{/* Action Buttons */}
			<Box
				sx={{
					padding: "8px 45px 45px 45px",
					gap: "8px",
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Skeleton
					variant='rectangular'
					width={80}
					height={36}
					sx={{ borderRadius: 1 }}
				/>
				<Skeleton
					variant='rectangular'
					width={120}
					height={36}
					sx={{ borderRadius: 1 }}
				/>
			</Box>
		</Box>
	);
}

export default ReassignmentSectionSkeleton;
